// Supabase's generated types declare every RPC as returning `Json`, which has no
// properties to read. These narrow the two credit RPCs to the shapes their SQL
// functions actually return (see supabase/migrations/20260823120000_*), with a
// runtime check so a malformed response is treated as "no result" rather than
// read blindly.

/** `check_balance(p_user_id)` */
export interface BalanceResult {
  balance: number;
  lifetime_earned?: number;
  lifetime_used?: number;
  voucher_code?: string | null;
}

/** `apply_voucher(p_user_id, p_code)` */
export interface VoucherResult {
  success: boolean;
  error?: string;
  credits_added?: number;
  new_balance?: number;
}

const isObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export function asBalanceResult(data: unknown): BalanceResult | null {
  return isObject(data) && typeof data.balance === 'number' ? (data as unknown as BalanceResult) : null;
}

export function asVoucherResult(data: unknown): VoucherResult | null {
  return isObject(data) && typeof data.success === 'boolean' ? (data as unknown as VoucherResult) : null;
}
